module.exports = __webpack_public_path__ + "img/baas_39.b9a09cf4.png";